export function getRenotarizationLogsRequest(
  { limit, page, clientId, yourNumber, restampResult, dateStart, dateEnd } = {},
  onSuccess
) {
  return {
    type: '@renotarizationLogs/GET_REQUEST',
    payload: {
      limit,
      page,
      clientId,
      yourNumber,
      restampResult,
      dateStart,
      dateEnd,
      onSuccess,
    },
  };
}

export function getRenotarizationLogsSuccess(data) {
  return {
    type: '@renotarizationLogs/GET_SUCCESS',
    payload: { data },
  };
}

export function getRenotarizationHistoryRequest(yourNumber, clientId) {
  return {
    type: '@renotarizationLogs/GET_HISTORY_REQUEST',
    payload: { yourNumber, clientId },
  };
}

export function getRenotarizationHistorySuccess(history) {
  return {
    type: '@renotarizationLogs/GET_HISTORY_SUCCESS',
    payload: { history },
  };
}

export function renotarizationLogsFailure() {
  return {
    type: '@renotarizationLogs/FAILURE',
  };
}
